import { appEnv } from 'src/util/appEnv'

export const getBasePath = () => {
  if (appEnv.isLocal) return 'http://localhost:18888'
  if (appEnv.isDevelopment) return 'https://api.report.kaminashi-dev.com'
  if (appEnv.isProduction) return 'https://api.report.kaminashi.com'
  throw new Error('環境の判定に失敗しました')
}

export const getKaminashiIDBasePath = () => {
  if (appEnv.isLocal) return 'http://localhost:4000'
  if (appEnv.isDevelopment) return 'https://dev.id.kaminashi.com'
  if (appEnv.isProduction) return 'https://id.kaminashi.com'
  throw new Error('環境の判定に失敗しました')
}

export const getCampaignsApiUrl = () => {
  // ローカルは public/mocks のフィクスチャを読む
  if (appEnv.isLocal) return '/mocks/campaigns.json'
  if (appEnv.isDevelopment)
    return 'https://dev.campaign-banners.kaminashi.com/api/campaigns'
  if (appEnv.isProduction)
    return 'https://campaign-banners.kaminashi.com/api/campaigns'
  throw new Error('環境の判定に失敗しました')
}

const haramiMockApiEndpoints: readonly string[] = (
  import.meta.env.VITE_HARAMI_MOCK_API_ENDPOINTS ?? ''
)
  .split(',')
  .map((endpoint: string) => endpoint.trim())
  .filter((endpoint: string) => endpoint.length > 0)

export const getHaramiMockApiEndpoints = () => {
  return haramiMockApiEndpoints
}
